const DownSvg = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M18 9L12 15L6 9" stroke="#CCD2E3" stroke-width="2" />
    </svg>
  )
}

export default DownSvg
